import { onChangeMoveToContext, onViewAllMenuClicked } from '../actions/internalActions';
import { lazyGetArchiveFolders, lazyGetSharedFoldersForSpecificRoot } from 'owa-folders';
import { orchestrator } from 'satcheljs';

const VIEW_ALL_MOVE_TO_MENU = 'VIEW_ALL_MOVE_TO_MENU';

// gets called when user clicks on view all menu item for any mailbox
orchestrator(onViewAllMenuClicked, async actionMessage => {
    onChangeMoveToContext(actionMessage.moveToMailboxContext);
    switch (actionMessage.moveToMailboxContext) {
        case 'archive':
            (await lazyGetArchiveFolders.import())(
                VIEW_ALL_MOVE_TO_MENU /* Archive mailbox folders loading source */
            );
            break;
        case 'sharedFolder':
            (await lazyGetSharedFoldersForSpecificRoot.import())(
                actionMessage.rootFolderId /* Specific shared folder primary SMTP address */,
                'moveToControl' /* actionSource */
            );
            break;
        default:
            return;
    }
});
